import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { CountryStateCityService } from 'src/app/modules/edit-preference/components/personal-info/country-state-city.service';
import { Subject, takeUntil } from 'rxjs';
import { keyPress } from 'src/app/utils/common.utils';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { CommonModule } from '@angular/common';
import { PhoneMaskDirective } from '../../directive/phone-mask.directive';
import { SsnMaskDirective } from '../../directive/ssn-mask.directive';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { InfoIconComponent } from 'src/app/components/info-icon/info-icon.component';

@Component({
  selector: 'app-mobile-input',
  templateUrl: './mobile-input.component.html',
  styleUrls: ['./mobile-input.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PhoneMaskDirective,
    SsnMaskDirective,
    ValidationErrorsComponent,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    InfoIconComponent
  ]
})
export class MobileInputComponent implements OnInit, AfterViewInit {
  @Input() field: Field;
  @Input() form: FormGroup;
  maxLength = 0;
  countryList = null;
  private destroy$ = new Subject<void>();

  constructor(
    private readonly countryStateCityService: CountryStateCityService,
    public readonly cs: CommonService
  ) {}

  onCountryChange(event: any) {
    this.form.get(this.field.name).setValue('');
    this.getCountryMaxLength(event.iso2);
  }

  ngOnInit() {
    if (this.cs.isBrowser) {
      this.countryStateCityService
        .getJSONCountry()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.countryList = data;
          this.getCountryMaxLength(this.field.mobile.selectedCountryISO);
        });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const mobileControl = this.form.get(this.field.name);
      if (mobileControl) {
        mobileControl.markAsUntouched();
        mobileControl.markAsPristine();
      }
    }, 100);
  }

  getCountryMaxLength(countryIso: string) {
    if (!countryIso) return;
    countryIso = countryIso.toUpperCase();
    const countryData = this.countryList.find(
      (country) => country.iso2 === countryIso
    );
    this.maxLength = countryData?.phoneLength;
  }

  onKeyPress(event: KeyboardEvent) {
    keyPress(event, this.maxLength, this.form.get(this.field.name));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
